import React from 'react';
import cn from 'classnames';
import * as T from 'prop-types';
import Popout from '@au/core/lib/components/objects/Popout';
import AuButton, { BUTTON_TYPE_PLAIN, BUTTON_TYPE_TERTIARY } from '@au/core/lib/components/elements/AuButton';
import JsonViewer from './JsonViewer';

import styles from '../css/components/view_json.module.scss';

export default class ViewJson extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isPopoutOpen: false,
    };
  }

  renderPopout() {
    if (this.state.isPopoutOpen) {
      const { data, expandLevel } = this.props;
      const jsonData = data?.toJS?.() || data || {};

      return (
        <Popout
          className={cn(styles.popout_container)}
          buttonClassName={styles.json_button}
          nuevo
          resizable
          onCloseClick={() => this.setState({ isPopoutOpen: false })}
          initialWidth={700}
          minWidth={700}
          maxWidth={1000}
        >
          <JsonViewer
            defaultExpand={true}
            data={jsonData}
            copyBtnDisplayId='au.jsonViewer.copyToClipboard'
            copyBtnClassName={styles.copy_btn}
            buttonType={BUTTON_TYPE_TERTIARY}
            copiedClassName={styles.copied}
            type={JsonViewer.TYPE.JsonEditor}
            expandLevel={expandLevel}
          />
        </Popout>
      );
    }
  }

  render() {
    return (
      <div className='view-json'>
        <AuButton
          type={BUTTON_TYPE_PLAIN}
          displayId='au.entity.viewJson'
          className={styles.view_json}
          onClick={() => this.setState({ isPopoutOpen: true })}
        />
        {this.renderPopout()}
      </div>
    );
  }
}

ViewJson.propTypes = {
  data: T.oneOfType([T.object, T.shape({ toJS: T.func })]),
  defaultExpand: T.bool,
  expandLevel: T.number,
};
